var _defs, _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectArrowError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1001",
    width: 30,
    height: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fc5c5c",
    d: "M18.0001 13.1531L15 15.8286L11.9999 13.153C11.7712 12.949 11.4003 12.949 11.1716 13.153C10.9428 13.357 10.9428 13.6878 11.1716 13.8918L14.4851 16.8469C14.6251 16.9718 14.8184 17.0202 14.9997 16.9922C15.1812 17.0204 15.3748 16.972 15.5149 16.847L18.8284 13.8919C19.0572 13.6879 19.0572 13.3571 18.8284 13.1531C18.5997 12.9491 18.2288 12.9491 18.0001 13.1531Z",
    className: "color0A0B0C svgShape"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29.5,
    height: 29.5,
    x: 0.25,
    y: 0.25,
    stroke: "#fc5c5c",
    strokeWidth: 0.5,
    rx: 14.75,
    className: "colorStrokeCDD3D9 svgStroke"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrowError);
export default __webpack_public_path__ + "static/media/select-arrow-error.b21ae05406f0254fa9cb143bb18ae180.svg";
export { ForwardRef as ReactComponent };